import { Typography } from '@mui/material';
import React from 'react';

const ComingSoon = ({sx}: {sx?: any}) => {
    return (
        <Typography variant='h6' sx={{fontWeight: 500, my: '20px', ...sx}}>
            Coming Soon!
        </Typography>
    )
}

export default ComingSoon;